import { MockCard, MockButton, MockWarning } from '../../components/mockups/MockUI'
import { MockTable } from '../../components/mockups/MockTable'

export function PlanningPlanFactTable() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Таблица план/факт
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Раздел «Планирование» — план и факт продаж по менеджерам. Правят ADMIN и РОП; бухгалтер
          вносит только факт (сумму и АКБ), план ему недоступен. Генеральный директор видит раздел в
          режиме просмотра, Помощник — только просмотр прикреплённых к нему менеджеров. РОП видит
          менеджеров своих городов и не может править собственную строку — его план и факт ставит
          админ.
        </p>
      </div>
      <MockTable
        caption="Основная таблица (суммы в рублях)"
        columns={[
          { header: '', width: '40px' },
          { header: 'Менеджер' },
          { header: 'План, ₽' },
          { header: 'Факт, ₽' },
          { header: '%' },
          { header: 'КП выставлено, ₽' },
          { header: 'В заказ, ₽' },
        ]}
        rows={[
          [
            '☑',
            'Иванов Пётр',
            '2 000 000',
            '2 080 000',
            <span className="text-emerald-600 font-semibold">104%</span>,
            '3 450 000',
            '1 820 000',
          ],
          [
            '☑',
            'Ольга К.',
            '1 500 000',
            '810 000',
            <span className="text-amber-500 font-semibold">54%</span>,
            '1 670 000',
            '490 000',
          ],
          [
            '☐',
            'Тестовый',
            '1 000 000',
            '120 000',
            <span className="text-red-500 font-semibold">12%</span>,
            '380 000',
            '0',
          ],
          [
            '',
            <span className="font-medium">Итого:</span>,
            <span className="font-medium">4 500 000</span>,
            <span className="font-medium">3 010 000</span>,
            <span className="text-amber-500 font-semibold">66.9%</span>,
            <span className="font-medium">5 500 000</span>,
            <span className="font-medium">2 310 000</span>,
          ],
        ]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Колонки:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Чекбокс — включает менеджера в рейтинги план/факт на странице «Дашборд» (выбор общий
              для всех виджетов)
            </li>
            <li>«Менеджер» — имя, роль (Менеджер/РОП) и email</li>
            <li>
              «План, ₽» и «Факт, ₽» — редактируются прямо в ячейке: кликните, введите сумму, Enter
              или уход с поля сохраняет. Вводятся только цифры, тысячи автоматически разделяются
              пробелами. Под «Факт» — дата последнего изменения (или «ещё не менялся»)
            </li>
            <li>
              «%» — выполнение плана: красный меньше 30%, жёлтый 30–70%, зелёный от 70%. Если план
              не задан — «—»
            </li>
            <li>
              «КП выставлено, ₽» — расчётная: сумма позиций из КП менеджера за период. По каждой
              позиции берётся цена с наценкой из самого свежего КП заявки, где она есть, ×
              количество
            </li>
            <li>
              «В заказ, ₽» — расчётная: позиции в статусе «Счёт» (ORDERED), попавшие в период.
              Считается по зафиксированной цене заказа — изменения квот и курсов на неё уже не
              влияют
            </li>
            <li>Внизу — строка «Итого:» по всем колонкам</li>
          </ul>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-3">
          <div className="font-medium text-gray-800 dark:text-gray-200">Период:</div>
          <div className="flex items-center gap-2 flex-wrap">
            <MockButton variant="secondary">Месяц</MockButton>
            <MockButton variant="secondary">Квартал</MockButton>
            <MockButton variant="secondary">Год</MockButton>
            <MockButton variant="secondary">Период…</MockButton>
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>«Месяц» — выбор конкретного месяца</li>
            <li>«Квартал» — год стрелками ‹ › + кнопки Q1–Q4</li>
            <li>«Год» — номер года; для текущего года факт считается с января по текущий месяц</li>
            <li>«Период…» — произвольный диапазон дат в календаре</li>
          </ul>
          <p>
            Выбранный период подписан мелким шрифтом под заголовками «План, ₽» и «Факт, ₽» —
            например «Июль» или «III кв · июл–сен».
          </p>
        </div>
      </MockCard>
      <MockWarning>
        Если выбран период длиннее месяца (квартал, год, диапазон) — в таблице показана сумма за все
        месяцы, а редактирование плана/факта применяется к первому месяцу периода. Чтобы править
        другие месяцы, переключитесь на «Месяц».
      </MockWarning>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Поиск:</div>
          <p>
            Поле «Поиск менеджера…» фильтрует таблицу по имени и email, рядом счётчик «найдено X из
            Y». Чекбокс в шапке выбирает всех менеджеров из отфильтрованного списка — удобно быстро
            собрать группу для рейтинга. Строка менеджера видна даже если план ещё не заводили — с
            нулями; первое редактирование создаст запись.
          </p>
        </div>
      </MockCard>
    </div>
  )
}

export function PlanningAkb() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          АКБ — план/факт по клиентам
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Блок «АКБ» (активная клиентская база) — под основной таблицей на той же странице
          «Планирование». План и факт по количеству клиентов, цифры — штуки, не деньги.
        </p>
      </div>
      <MockTable
        caption="Таблица АКБ"
        columns={[
          { header: 'Менеджер' },
          { header: 'План, шт' },
          { header: 'Факт, шт' },
          { header: '%' },
        ]}
        rows={[
          ['Иванов Пётр', '25', '21', <span className="text-emerald-600 font-semibold">84%</span>],
          ['Ольга К.', '20', '9', <span className="text-amber-500 font-semibold">45%</span>],
          [
            <span className="font-medium">Итого:</span>,
            <span className="font-medium">45</span>,
            <span className="font-medium">30</span>,
            <span className="text-amber-500 font-semibold">66.7%</span>,
          ],
        ]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Отличия от основной таблицы:
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Без чекбоксов — выбор менеджеров для рейтингов на дашборде делается в основной таблице
            </li>
            <li>Без колонок «КП выставлено» и «В заказ» — это финансовые показатели</li>
            <li>«План, шт» и «Факт, шт» — целые числа клиентов</li>
          </ul>
          <div className="font-medium text-gray-800 dark:text-gray-200 mt-3">Что совпадает:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>Редактирование прямо в ячейке, сохранение по Enter или уходу с поля</li>
            <li>Под «Факт, шт» — дата последнего изменения</li>
            <li>«%» с той же подсветкой: красный &lt;30%, жёлтый 30–70%, зелёный от 70%</li>
            <li>Строка «Итого:» и подпись периода под заголовками колонок</li>
            <li>При периоде длиннее месяца редактирование применяется к первому месяцу периода</li>
            <li>РОП не правит собственную строку; Генеральный директор — только просмотр</li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function PlanningRating() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Рейтинг план/факт на дашборде
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          На странице «Дашборд» (ADMIN, РОП, Генеральный директор) два виджета: «Рейтинг план /
          факт» — по деньгам, и «Рейтинг АКБ план / факт» — по количеству клиентов. Каждый менеджер
          — горизонтальный бар, заполненный на процент выполнения плана.
        </p>
      </div>
      <MockCard>
        <div className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
          Рейтинг план / факт
        </div>
        <div className="space-y-2 select-none">
          {[
            {
              i: 1,
              name: 'Иванов Пётр',
              w: '100%',
              c: '#16a34a',
              pf: '2.0M / 2.1M',
              pct: '104%',
              mark: '✓',
            },
            {
              i: 2,
              name: 'Ольга К.',
              w: '54%',
              c: '#ea580c',
              pf: '1.5M / 0.81M',
              pct: '54%',
              mark: '',
            },
            {
              i: 3,
              name: 'Тестовый',
              w: '12%',
              c: '#dc2626',
              pf: '1.0M / 0.12M',
              pct: '12%',
              mark: '⚠',
            },
          ].map((r) => (
            <div key={r.i} className="flex items-center gap-3">
              <span className="w-4 text-xs text-gray-400 text-right">{r.i}</span>
              <span className="w-28 text-sm text-gray-800 dark:text-gray-200 truncate">
                {r.name}
              </span>
              <div className="flex-1 h-5 bg-gray-100 dark:bg-gray-700 rounded-md overflow-hidden">
                <div className="h-full rounded-md" style={{ width: r.w, background: r.c }} />
              </div>
              <span className="w-24 text-xs text-gray-500 dark:text-gray-400 text-right tabular-nums">
                {r.pf}
              </span>
              <span className="w-12 text-sm font-semibold text-right tabular-nums text-gray-800 dark:text-gray-200">
                {r.pct}
              </span>
              <span className="w-4 text-xs">{r.mark}</span>
            </div>
          ))}
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Кто попадает в рейтинг:
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>Менеджеры, отмеченные чекбоксом в таблице раздела «Планирование»</li>
            <li>
              Тот же выбор можно менять чипами в блоке «Выбор менеджера» наверху дашборда — чип «Все
              менеджеры» выбирает всех разом
            </li>
            <li>
              Выбор общий для всех виджетов дашборда и хранится в профиле пользователя — сохраняется
              между страницами и устройствами
            </li>
          </ul>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Как читать виджет:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>Сортировка — по проценту выполнения, лучшие сверху</li>
            <li>
              Цвет бара: зелёный от 90% (плюс отметка ✓), синий 70–89%, оранжевый 45–69%, красный
              меньше 45% (плюс отметка ⚠)
            </li>
            <li>
              Подпись справа — «план / факт»: деньги в компактном формате (например «2.0M»), АКБ — в
              штуках
            </li>
            <li>Менеджеры без плана в бары не попадают — перечислены снизу строкой «Без плана»</li>
          </ul>
          <p className="mt-2">
            Период берётся из общего селектора дашборда. Рейтинг считается для периодов «Месяц»,
            «Квартал», «Год» и «Период…» — для «День» и «Неделя» виджет покажет подсказку вместо
            баров. Если план не задан ни у кого — виджет предложит заполнить его на странице
            «Планирование».
          </p>
        </div>
      </MockCard>
      <MockWarning>
        Источник факта в рейтинге — колонка «Факт, ₽» (для АКБ — «Факт, шт») из раздела
        «Планирование». Это ручной ввод админа или РОПа, а не автоматический расчёт: пока факт не
        обновили, рейтинг показывает старые цифры.
      </MockWarning>
    </div>
  )
}
